import React from 'react'

type props = {
    children: React.ReactNode;
}

const SearchResultTitle = ({children}: props) => {
    return (
        <h4 
                style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}
            > 
                {children}
        </h4>
    )
}

export default SearchResultTitle